export const ActionTypes = {
    UPDATE_INSTANCE_DETAIL: "UPDATE_INSTANCE_DETAIL",

    API_RESPONSE_SUCCESS: 'API_RESPONSE_SUCCESS',
}
